import { GoogleMap, MarkerF, useJsApiLoader } from "@react-google-maps/api";

import Preloader from "../UI/Preloader/Preloader";
import Property from "../../rest/Property";

interface LocationMapProps {
	property: Property;
}

export default function LocationMap({ property }: LocationMapProps) {
	const { isLoaded: isMapLoaded } = useJsApiLoader({
		id: "google-map-script",
		googleMapsApiKey: "AIzaSyAN477EE2V4tlgeydyDzCAsuS6EJ9yejjE",
	});

	if (!property.googleLatLng) {
		return <></>;
	} else if (!isMapLoaded) {
		return <Preloader />;
	}

	return (
		<GoogleMap
			mapContainerStyle={{
				width: "100%",
				height: "50vh",
			}}
			center={property.googleLatLng}
			zoom={18}
		>
			{/* NB: Using MarkerF because Marker doesn't work presently,
			see https://github.com/JustFly1984/react-google-maps-api/issues/3019 */}
			<MarkerF position={property.googleLatLng} />
		</GoogleMap>
	);
}
